import type { SliceRouteContract } from '@/shared/lib/vsa';
import { LegacyFormSlicePage } from './LegacyFormSlicePage';

export const legacyFormRouteContract: SliceRouteContract = {
  routeId: 'legacy-form',
  component: LegacyFormSlicePage,
};
